import { DrupalRole } from '~/stores/drupalUser'

type UseDrupalRoleHelper = {
  roleLabels: ComputedRef<Record<DrupalRole, string>>
}

export function useDrupalRoleHelper(): UseDrupalRoleHelper {
  const { $texts } = useEasyTexts()

  const roleLabels = computed<Record<DrupalRole, string>>(() => ({
    [DrupalRole.AffiliatedPharmacy]: $texts(
      'role.affiliatedPharmacy',
      'angeschlossene Apotheke',
    ),
    [DrupalRole.NonAffiliatedPharmacy]: $texts(
      'role.nonAffiliatedPharmacy',
      'nicht angeschlossene Apotheke',
    ),
    [DrupalRole.IndividualMember]: $texts(
      'role.individualMember',
      'Einzelmitglied',
    ),
    [DrupalRole.NonMember]: $texts('role.nonMember', 'Nichtmitglied'),
  }))

  return { roleLabels }
}
